var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass:
          "panel bg-transparent columns large-8 medium-12 large-centered text-center",
      },
      [
        _vm.componentReady
          ? _c("div", { staticClass: "text-left" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "columns large-6 medium-12" }, [
                  _c("table", { staticStyle: { width: "100%" } }, [
                    _c("tr", [
                      _c("td", [
                        _c("h6", {
                          staticStyle: { display: "inline" },
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("forms.login_cred.IC_0010")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("a", {
                          staticClass: "fa-edit fa fa-fw fa-lg float-button",
                          on: {
                            click: function ($event) {
                              return _vm.openModal("admin")
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "indent" }, [
                        _c("label", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("forms.new_contractor_contact.IC_0001")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.adminInfo.Firstname
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("forms.new_contractor_contact.IC_0002")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.adminInfo.Lastname
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", { staticStyle: { color: "lightgrey" } }, [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("include.DBcontrol.IC_0038")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.adminInfo.Email
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("forms.new_contractor_contact.IC_0005")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.adminInfo.Tel
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("forms.new_contractor_contact.IC_0008")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.adminInfo.Street
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("forms.new_contractor_contact.IC_0009")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.adminInfo.City
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("forms.new_contractor_contact.IC_0010")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.adminInfo.Province
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("forms.new_contractor_contact.IC_0011")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.adminInfo.Country
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s("Postal Code/Zipcode"),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.adminInfo.Postal
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "columns large-6 medium-12" }, [
                  _c("table", { staticStyle: { width: "100%" } }, [
                    _c("tr", [
                      _c("td", { staticClass: "text-center" }, [
                        _c("h6", {
                          staticStyle: { display: "inline" },
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("forms.company_edit.IC_0001")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("a", {
                          staticClass: "fa-edit fa fa-fw fa-lg float-button",
                          on: {
                            click: function ($event) {
                              return _vm.openModal("company")
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "indent" }, [
                        _c("label", { staticStyle: { color: "lightgrey" } }, [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("forms.new_contractor_company.IC_0032")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.memberInfo.Name
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("forms.new_contractor_company.IC_0042")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.memberInfo.OperatingAs
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("forms.new_contractor_company.IC_0033")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.memberInfo.Street
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("forms.new_contractor_company.IC_0034")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.memberInfo.City
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("forms.new_contractor_contact.IC_0010")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.memberInfo.Province
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("forms.new_contractor_contact.IC_0011")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.memberInfo.Country
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s("Postal Code/Zipcode"),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.memberInfo.Postal
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _c("strong", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("forms.new_contractor_company.IC_0038")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.displayData.memberInfo.MainTel
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _vm.displayData.memberInfo.GST
                          ? _c("label", [
                              _c("strong", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.t("member_basic_edit.IC_0073")
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.displayData.memberInfo.GST
                                  ),
                                },
                              }),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "columns large-6 medium-12" }, [
                  _c("table", { staticStyle: { width: "100%" } }, [
                    _c("tr", [
                      _c("td", [
                        _c("h6", {
                          staticStyle: { display: "inline" },
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("directory_edit2.IC_0004")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("a", {
                          staticClass: "fa-edit fa fa-fw fa-lg float-button",
                          on: {
                            click: function ($event) {
                              return _vm.openModal("services")
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "indent" }, [
                        _c(
                          "ul",
                          _vm._l(
                            _vm.displayData.memberServices,
                            function (service) {
                              return _c("li", {
                                domProps: { textContent: _vm._s(service.Text) },
                              })
                            }
                          ),
                          0
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "columns large-6 medium-12" }, [
                  _c("table", { staticStyle: { width: "100%" } }, [
                    _c("tr", [
                      _c("td", [
                        _c("h6", {
                          staticStyle: { display: "inline" },
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("forms.new_contractor_jurs.IC_0001")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("a", {
                          staticClass: "fa-edit fa fa-fw fa-lg float-button",
                          on: {
                            click: function ($event) {
                              return _vm.openModal("jurs")
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "indent" }, [
                        _c(
                          "ul",
                          _vm._l(_vm.displayData.memberJurs, function (jurs) {
                            return _c("li", {
                              domProps: { textContent: _vm._s(jurs.name) },
                            })
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row", attrs: { "data-equalizer": "" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "columns large-6 medium-12",
                      attrs: { "data-equalizer-watch": "" },
                    },
                    [
                      _c("table", { staticStyle: { width: "100%" } }, [
                        _c("tr", [
                          _c("td", [
                            _c("h6", {
                              staticClass: "uppercase",
                              staticStyle: { display: "inline" },
                              domProps: {
                                textContent: _vm._s(
                                  _vm.t(
                                    "forms.new_contractor_numemployees.IC_0000"
                                  )
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("a", {
                              staticClass:
                                "fa-edit fa fa-fw fa-lg float-button",
                              on: {
                                click: function ($event) {
                                  return _vm.openModal("peak")
                                },
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", {
                            staticClass: "indent",
                            domProps: { textContent: _vm._s(_vm.peakNumber) },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showSubset
                    ? _c(
                        "div",
                        {
                          staticClass: "columns large-6 medium-12",
                          attrs: { "data-equalizer-watch": "" },
                        },
                        [
                          _c("table", { staticStyle: { width: "100%" } }, [
                            _c("tr", [
                              _c("td", [
                                _c("h6", {
                                  staticStyle: { display: "inline" },
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.t(
                                        "xajax.newcontractor.server.IC_0063"
                                      )
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("a", {
                                  staticClass:
                                    "fa-edit fa fa-fw fa-lg float-button",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openModal("subsets")
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "td",
                                { staticClass: "indent" },
                                _vm._l(
                                  _vm.subsetInfo.availableSubsets,
                                  function (subsets) {
                                    return _c("div", [
                                      _c("strong", {
                                        domProps: {
                                          textContent: _vm._s(
                                            subsets.Name +
                                              " (" +
                                              subsets.Title +
                                              ")"
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        _vm._l(
                                          _vm.filterSelectedSubset(
                                            subsets.Subsets
                                          ),
                                          function (subsetName) {
                                            return _c("li", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  subsetName.Name
                                                ),
                                              },
                                            })
                                          }
                                        ),
                                        0
                                      ),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "columns large-4" }, [
                  _vm._v("\n           \n        "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "columns large-4" }, [
                  _c("button", {
                    staticClass: "tiny radius expand",
                    domProps: {
                      textContent: _vm._s(_vm.t("register.payment")),
                    },
                    on: { click: _vm.completeRegistration },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "columns large-4" }, [
                  _vm._v("\n           \n        "),
                ]),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.componentReady
          ? _c("div", [_c("i", { staticClass: "fa fa-spinner fa-spin fa-2x" })])
          : _vm._e(),
        _vm._v(" "),
        _vm.showModal
          ? _c(
              "modal",
              {
                attrs: { size: "medium", "show-close-button": true },
                on: {
                  close: function ($event) {
                    _vm.showModal = false
                  },
                },
              },
              [
                _c(_vm.modalComponent, {
                  tag: "component",
                  attrs: { "ge-member-ids": _vm.geMemberIds },
                  on: { complete: _vm.updateComplete },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showGeNotice
          ? _c(
              "modal",
              {
                staticClass: "ge-notification-modal",
                attrs: { size: "medium", "show-close-button": true },
                on: {
                  close: function ($event) {
                    _vm.showGeNotice = false
                  },
                },
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "medium-4 columns" }, [
                    _c("img", {
                      staticClass: "ge-notice-icon",
                      attrs: { src: _vm.geImg },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "medium-8 text-left columns ge-notice-text",
                    },
                    [
                      _c("p", {
                        staticClass: "highlighter emphasis",
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("register.ge_review_title")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("p"),
                      _c("h5", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("register.ge_review_upgrade")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "ge-note",
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("register.ge_review_upgrade_info")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("p"),
                      _vm._v(" "),
                      _c("p"),
                      _c("h5", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("register.ge_review_reminder")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "ge-note",
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("register.ge_review_reminder_info")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("p"),
                      _vm._v(" "),
                      _c("p", { staticClass: "no-margin" }, [
                        _c("button", {
                          staticClass: "tiny",
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("templates.page.IC_0001")
                            ),
                          },
                          on: {
                            click: function ($event) {
                              _vm.showGeNotice = false
                            },
                          },
                        }),
                      ]),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "text-center" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }